import { render } from "./StafetAddDeltager.vue?vue&type=template&id=7b6e1a5f"
import script from "./StafetAddDeltager.vue?vue&type=script&lang=js"
export * from "./StafetAddDeltager.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__